/** How long a reaction stays on screen after its frame, in milliseconds. */
export const REACTION_HOLD_MS = 1000;

/**
 * Reactions whose stamp is at or just before the playhead, so they are
 * visible while the video plays through that frame.
 */
export function reactionsNearPlayhead(reactions, playheadMs, holdMs = REACTION_HOLD_MS) {
  const t = Number(playheadMs);
  if (!Number.isFinite(t)) return [];
  const hold = Math.max(200, Number(holdMs) || REACTION_HOLD_MS);
  return (Array.isArray(reactions) ? reactions : []).filter((row) => {
    const at = Number(row?.t_ms);
    if (!Number.isFinite(at) || !row?.emoji) return false;
    return t >= at && t < at + hold;
  });
}
